export default {
  GET_CATEGORY: 'getCategory',
  GET_ROL: 'getRol',
  GET_TABLE_CONFIG: 'getTableConfig',
  GET_FILTER: 'getFilter',
  GET_CURRENT_FILTER: 'getCurrentFilter',
  GET_EVENTS: 'getEvents',
};
